import { PowerBiObjectModel } from './../_models/DAL/PowerBiObject.model';
import { CommonTools } from '../_helpers/common.tools';
import { Injectable } from '@angular/core';
import { RoleModel } from '../_models/DAL/Role.model';
import { UserOrGroupModel } from '../_models/DAL/UserOrGroup.model';
import { ApiClhubService } from './apiClhub.service';
import { JDebug } from '../_helpers/debug.tools';
export const WITHOUT_ROLE: string = '[WITHOUT_ROLE]';
export const ADD: string = 'add';
export const UPDATE:string = 'update';
@Injectable({
  providedIn: 'root'
})
export class BiObjectHelperService {


  constructor(private ApiClient: ApiClhubService){}


  /******UTILS */


   /**
   * @function setRolesToPBIObject
   * This function assigns roles to a PowerBiObjectModel object.
   * -------------------------------------------------
   * It does nothing :
   * * if the target is null,
   * * if the target has more than one role, or
   * * if no roles are provided.
   * -------------------------------------------------
   * @argument target : PowerBiObjectModel Object to Set
   * @argument roles  : Roles to moves
   * -------------------------------------------------
   * FORMAT OF NEW ROLES :
   *
   * roles :[
   *   {
   *     "access": [],
   *     "name": "value",
   *     "azureObjectId": "value",
   *     "isGroup": false,
   *     "isUser": true
   *   },
   *   "theRole": "[ROLE_NAME]"
   * ]
  * **/
  public setRolesToPBIObject(target: PowerBiObjectModel, roles: Array<RoleModel>){
    // Target must be not undefined and have an empty roles list
    if(!target || target.roles.length != 0) return;

    const newRoleList = roles.map(role => {
      const newRole = new RoleModel();
      newRole.theRole = role.theRole;
      newRole.usersOrGroups = role.usersOrGroups.map(user => {
        const userDelta = new UserOrGroupModel();
        userDelta.name = user.name;
        userDelta.azureObjectId = user.azureObjectId;
        userDelta.isGroup = user.isGroup;
        userDelta.isUser = user.isUser;
        return userDelta;
      });
      return newRole;
    });
    newRoleList.sort((a, b) => CommonTools.BaseSortCb(a.theRole, b.theRole));
    target.roles = newRoleList;
  }


  /*

TRANSFERT
*/
async duplicateRoles(target: PowerBiObjectModel, source: PowerBiObjectModel) {
  //controls & confirm PopUp?
  if (target != undefined && target.id != -1) {

    target.currentUserAzureObjectId = source.currentUserAzureObjectId;

    this.setRolesToPBIObject(target, source.roles);

    if (target.id == 0) {
      //reset other properties for creation
      target.isCubeConnection = false;
      target.displayFilterTable = false;
      target.isDashboard =false;
      target.isReport=true;
      target.accessLog=[];

      this.managePBIO(ADD,target);

    }else{

      this.managePBIO(UPDATE,target);
    }
  }


}



  setRolesToTarget(target: PowerBiObjectModel, roles: Array<RoleModel>){
    // Target must be not undefined and have an emty roles list
    if(!target || target.roles.length !=0) return;
    // Assigns the provided roles to the target with the target's ID.
    target.roles = roles.map(role => ({ ...role, powerBIObjectId: target.id }));
  }


  inflateRole(obj: any) {
    let role = new RoleModel();
    role.id = obj['id'];
    role.theRole = obj['theRole'];
    role.powerBIObjectId = obj['powerBIObjectId'];
    role.modifiedBy = obj['modifiedBy'];
    role.modifiedOn = obj['modifiedOn'];
    return role;
  }


  /*CRUPDATE*/

  managePBIO( action : string ,PBIO: PowerBiObjectModel): Promise<void> {
    const endpoint = action === ADD ? 'PowerBiObject/custom-add' : 'PowerBIObject/custom-edit-with-reset';
    return this.postObjectToClient(PBIO, endpoint);
  }

  private async postObjectToClient(PBIO: PowerBiObjectModel, endpoint: string): Promise<void> {
    try {
      let posted = JSON.stringify(PBIO);
      console.log(`posted : ${posted}`);
      const response = await this.ApiClient.post(endpoint,posted ).toPromise();
      JDebug.logValue(response);
    } catch (err) {
      console.error(`Error on post ${endpoint}`, err);
    }
  }








  /*GET ARRAYS*/


  async getEmptyReportsList(azureWorkspaceId : string): Promise<PowerBiObjectModel[]> {
    JDebug.logValue(azureWorkspaceId);
    let ret = new Array<PowerBiObjectModel>();

    let res = await this.getClhubReportByGroupGuid(azureWorkspaceId);
    if (res) {
      for (const pbiom of res) {
        await this.getAndSetRolesByPBIObjectId(pbiom);
      }
      ret = res.filter(report => report.roles.length < 1);
      JDebug.logArray(ret);
    }
    return ret;
  }
  async getAndSetRolesByPBIObjectId(powerBIObjectModel: PowerBiObjectModel) {

    const roles = await this.getClhubRolesByPowerBIObjectId( powerBIObjectModel.id );

    if (roles) {
      roles.forEach(obj => {
        const Role = this.inflateRole(obj);
        powerBIObjectModel.roles.push(Role);
        powerBIObjectModel.roles.sort((a, b) => CommonTools.BaseSortCb(a.theRole, b.theRole));
      });
    }
  }


  public  async getClhubPBIOByAzureObjectId(azureObjectId: string): Promise<PowerBiObjectModel[]> {
    return this.postForArray<PowerBiObjectModel>('PowerBiObject/filtered-list', { 'AzureObjectId': azureObjectId });
  }

  public  async getClhubRolesByPowerBIObjectId(powerBIObjectId: number): Promise<any> {
    return this.postForArray<Array<RoleModel>>('Role/filtered-list', { 'PowerBIObjectId': powerBIObjectId });
  }

  public  async getClhubUserOrGroupsByRolesId(id: number): Promise<any> {
    return this.postForArray<any>('UserOrGroup/GetUsersOrGroupsByRoleId', { 'RoleId': id });
  }

  public  async getClhubReportByGroupGuid(guid:string): Promise<any>{
    return this.getForArray<any>(`PowerBi/report-by-group?groupId=${guid}`);
  }
  public async getLastAccessLogListByRoleId(id : number): Promise<any>{
    return this.getForArray<any>(`AccessLog/last-accesslog-list/${id}`)
  }

  private  async getForArray<T>(endpoint: string): Promise<T[]>{
    try {
      return await this.ApiClient.get(endpoint).toPromise();
    } catch (err) {
      console.error(`Error fetching from GET : ${endpoint}`, err);
      throw err;
    }
  }

  private   async postForArray<T>(endpoint: string, body: any): Promise<T[]> {
    try {
      return await this.ApiClient.post(endpoint, body).toPromise();
    } catch (err) {
      console.error(`Error fetching from POST : ${endpoint} with body ${JSON.stringify(body)}`, err);
      throw err;
    }
  }


}
